import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Termsbanner from "../Pages/Terms/Terms";
import Termscenter from "../Pages/Terms/Termscenter";
import Latestupdate from "../Component/Latestupdate/Latestupdate";
import NFTPurchase from "Pages/NFTPurchase/NFTPurchase";
import NFTPurchasecenter from "Pages/NFTPurchase/NFTPurchasecenter";

export default function NFTPurchaseAndIPLicense_Agreement() {
  return (
    <>
      <Header />
      <NFTPurchase />
      <NFTPurchasecenter />
      <Footer />
    </>
  );
}
